import React, { ReactNode } from 'react'
import Scrollbar from 'react-scrollbars-custom'

// todo: use React.FC type
interface MenuListProps {
  children: ReactNode
}

function MenuList({ children }: MenuListProps) {
  return (
    <Scrollbar>
      {children}
    </Scrollbar>
  )
}

export default MenuList
